import styled, { css } from 'styled-components'

interface StyledTooltipProps {
  direction: string
  $wordWrap: boolean
  $noMaxWidth: boolean
  $parentGap: string
  $type: 'normal' | 'strong'
  $maxWidth?: string
}

export const StyledTooltip = styled.div<StyledTooltipProps>`
  &.tooltip-box {
    position: absolute;
    background-color: ${({ $type }) =>
      $type === 'strong' ? 'var(--bg-gray-strong)' : 'var(--bg-gray-normal)'};
    width: max-content;
    max-width: ${({ $noMaxWidth, $maxWidth }) => ($noMaxWidth ? 'unset' : $maxWidth || '23.6rem')};
    padding: 0.4rem 0.8rem;
    border-radius: 0.4rem;
    z-index: 10000;
    display: flex;

    ${({ $type }) =>
      $type === 'normal' &&
      css`
        box-shadow:
          0px 0px 8px 0px #24292f29,
          0px 0px 4px 0px #24292f29;
      `}

    .tail {
      position: absolute;
      padding: 0 0.8rem;
      path {
        fill: ${({ $type }) =>
          $type === 'strong' ? 'var(--bg-gray-strong)' : 'var(--bg-gray-normal)'};
      }
    }

    & > p {
      font: var(--body-small-400);
      color: var(--normal);
      ${(props) => (props.$wordWrap ? '' : 'word-break: break-all;')}
      & > .disabled {
        font: var(--body-small-400);
        color: var(--sec-orange-3);
      }
    }

    ${(props) =>
      props.direction === 'top' &&
      css`
        top: calc(100% + ${props.$parentGap});
        left: 50%;
        transform: translateX(-50%);
        .tail {
          top: -0.4rem;
          left: 50%;
          transform: translateX(-50%);
        }
      `};
    ${(props) =>
      props.direction === 'top-left' &&
      css`
        top: calc(100% + ${props.$parentGap});
        left: 0;
        .tail {
          top: -0.4rem;
          left: 0.4rem;
        }
      `};
    ${(props) =>
      props.direction === 'top-right' &&
      css`
        top: calc(100% + ${props.$parentGap});
        right: 0;
        .tail {
          top: -0.4rem;
          right: 0.4rem;
        }
      `};
    ${(props) =>
      props.direction === 'bottom' &&
      css`
        bottom: calc(100% + ${props.$parentGap});
        left: 50%;
        transform: translateX(-50%);
        .tail {
          bottom: -0.4rem;
          left: 50%;
          transform: translateX(-50%) rotate(180deg);
        }
      `};
    ${(props) =>
      props.direction === 'bottom-left' &&
      css`
        bottom: calc(100% + ${props.$parentGap});
        left: 0;
        .tail {
          bottom: -0.4rem;
          left: 0.4rem;
          transform: translateX(-50%);
          transform: rotate(180deg);
        }
      `};
    ${(props) =>
      props.direction === 'bottom-right' &&
      css`
        bottom: calc(100% + ${props.$parentGap});
        right: 0;
        .tail {
          bottom: -0.4rem;
          right: 0.4rem;
          transform: rotate(180deg);
        }
      `};
    ${(props) =>
      props.direction === 'right' &&
      css`
        right: calc(100% + ${props.$parentGap});
        top: 50%;
        transform: translateY(-50%);
        .tail {
          right: -1.4rem;
          top: 50%;
          transform: translateY(-50%) rotate(90deg);
        }
      `};
    ${(props) =>
      props.direction === 'right-top' &&
      css`
        right: calc(100% + ${props.$parentGap});
        top: 0;
        .tail {
          right: -1.4rem;
          top: 1.2rem;
          transform: translateY(-50%) rotate(90deg);
        }
      `};
    ${(props) =>
      props.direction === 'right-bottom' &&
      css`
        right: calc(100% + ${props.$parentGap});
        bottom: 0;
        .tail {
          right: -1.4rem;
          bottom: 0.8rem;
          transform: translateY(-50%) rotate(90deg);
        }
      `};
    ${(props) =>
      props.direction === 'left' &&
      css`
        left: calc(100% + ${props.$parentGap});
        top: 50%;
        transform: translateY(-50%);
        .tail {
          left: -1.4rem;
          top: 50%;
          transform: translateY(-50%) rotate(-90deg);
        }
      `};
    ${(props) =>
      props.direction === 'left-top' &&
      css`
        left: calc(100% + ${props.$parentGap});
        top: 0;
        .tail {
          left: -1.4rem;
          top: 1.2rem;
          transform: translateY(-50%) rotate(-90deg);
        }
      `};
    ${(props) =>
      props.direction === 'left-bottom' &&
      css`
        left: calc(100% + ${props.$parentGap});
        bottom: 0;
        .tail {
          left: -1.4rem;
          bottom: 0.8rem;
          transform: translateY(-50%) rotate(-90deg);
        }
      `};
  }
`
